import React from "react";
import {
  TextField,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@material-ui/core";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { dateLocale } from "@icarius-localization/strings";
import { getLocalizedString } from "@icarius-localization/strings";
import StepContainer from "./stepContainer";

const gridStyle = { height: 75, padding: "0px 10px" };

const StepOne = (props) => {

  const {
    evaluationTypeList,
    isCreate,
    formData,
    setFormValue,
    hasCollaborators,
  } = props;

  return (
    <StepContainer title={getLocalizedString("indicateParametersForNewEvaluationProcess")}>
      <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
        <TextField
          disabled={!isCreate}
          required
          fullWidth
          margin={"none"}
          label={getLocalizedString("centerCode")}
          value={formData.processCode}
          inputProps={{ maxLength: 20 }}
          onChange={(e) => setFormValue(e.target.value, "processCode")}
        />
      </Grid>
      <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
        <TextField
          required
          fullWidth
          margin={"none"}
          label={getLocalizedString("name")}
          value={formData.processName}
          inputProps={{ maxLength: 80 }}
          onChange={(e) => setFormValue(e.target.value, "processName")}
        />
      </Grid>
      <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateLocale}>
          <DatePicker
            fullWidth
            required
            label={getLocalizedString("evaluationStartDate")}
            cancelLabel={getLocalizedString("cancel")}
            okLabel={getLocalizedString("ok")}
            invalidDateMessage=''
            format="dd/MM/yyyy"
            margin="normal"
            value={formData.evaluationStartDate}
            onChange={(e) => setFormValue(e, "evaluationStartDate")}
            disabled={hasCollaborators}
          />
        </MuiPickersUtilsProvider>
      </Grid>
      <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateLocale}>
          <DatePicker
            fullWidth
            required
            label={getLocalizedString("evaluationEndDate")}
            cancelLabel={getLocalizedString("cancel")}
            okLabel={getLocalizedString("ok")}
            invalidDateMessage=''
            minDate={formData.evaluationStartDate}
            minDateMessage=''
            format="dd/MM/yyyy"
            margin="normal"
            value={formData.evaluationEndDate}
            onChange={(e) => setFormValue(e, "evaluationEndDate")}
            disabled={hasCollaborators}
          />
        </MuiPickersUtilsProvider>
      </Grid>
      <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateLocale}>
          <DatePicker
            disabled
            fullWidth
            required
            label={getLocalizedString("evaluationYear")}
            cancelLabel={getLocalizedString("cancel")}
            okLabel={getLocalizedString("ok")}
            invalidDateMessage=''
            format="yyyy"
            margin="normal"
            value={formData.evaluationYear}
            onChange={(e) => setFormValue(e, "evaluationYear")}
            views={["year"]}
          />
        </MuiPickersUtilsProvider>
      </Grid>
      <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateLocale}>
          <DatePicker
            fullWidth
            required
            label={getLocalizedString("evaluationPeriodShort")}
            cancelLabel={getLocalizedString("cancel")}
            okLabel={getLocalizedString("ok")}
            invalidDateMessage=""
            minDateMessage=""
            minDate={formData.evaluationStartDate}
            maxDate={formData.evaluationEndDate}
            format="MM/yyyy"
            margin="normal"
            value={formData.evaluationPeriod}
            onChange={(e) => setFormValue(e, "evaluationPeriod")}
            views={["month", "year"]}
          />
        </MuiPickersUtilsProvider>
      </Grid>
      <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
        <FormControl style={{ width: "100%" }}>
          <InputLabel required id={'label-evaluationType'}>{getLocalizedString("evaluationType")}</InputLabel>
          <Select
            value={formData.evaluationType}
            labelId={'label-evaluationType'}
            id={'select-evaluationType'}
            onChange={(e) => setFormValue(e.target.value, "evaluationType")}
            margin={"none"}
          >
            {
              evaluationTypeList?.map(item => (
                <MenuItem
                  className={"whiteText"}
                  key={item.key}
                  value={item.key}>
                  {item.value}
                </MenuItem>
              ))
            }
          </Select>
        </FormControl>
      </Grid>
      <Grid container item alignItems="center" xs={12} sm={6} style={gridStyle}>
        <FormControl style={{ width: "100%" }}>
          <InputLabel required id={'label-months'}>{getLocalizedString("seniorityRequiredToParticipate")}</InputLabel>
          <Select
            value={formData.months}
            labelId={'label-months'}
            id={'select-months'}
            onChange={(e) => setFormValue(e.target.value, "months")}
            margin={"none"}
            disabled={hasCollaborators}
          >
            {
              [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(item => (
                <MenuItem
                  className={"whiteText"}
                  key={item}
                  value={item}>
                  {item === 0 ? getLocalizedString("noSeniorityRequired") : `${item} ${item === 1 ? 'mes' : 'meses'}`}
                </MenuItem>
              ))
            }
          </Select>
        </FormControl>
      </Grid>
    </StepContainer>
  );
}

export default StepOne;